import * as React from 'react';

import { useDispatch } from 'react-redux';
import { ProCard } from 'components/icons';
import { pushModal } from 'redux/modules/modal';
import PaidSubscription from '../../components/PaidSubscription';
import PausedSubscriptionInfo from '../PausedSubscriptionInfo';
import usePausedSubscriptionInfo from '../PausedSubscriptionInfo/usePausedSubscriptionInfo';
import PaymentDetailsGate from '../PaymentDetailsGate/PaymentDetailsGateContainer';
import PaymentInfo from '../PaymentInfo';
import ProGrowSubscriptionCredits from './ProGrowSubscriptionCredits';
import ProGrowSubscriptionHeader from './ProGrowSubscriptionHeader';
import { block } from './utils';

export interface ProGrowSubscriptionProps {}

const ProGrowSubscription: React.FC<ProGrowSubscriptionProps> = () => {
  const { showPausedInfo, title, subtitle } = usePausedSubscriptionInfo();
  const dispatch = useDispatch();

  return (
    <PaidSubscription className={block()}>
      <ProGrowSubscriptionHeader />

      <PaidSubscription.Body>
        <PaymentDetailsGate>
          {showPausedInfo ? (
            <PausedSubscriptionInfo {...{ title, subtitle }} />
          ) : (
            <>
              <PaymentInfo
                cardElement={<ProCard />}
                onUpdatePlanClick={() =>
                  dispatch(pushModal({ name: 'AdjustPlan' }))
                }
              />
              <ProGrowSubscriptionCredits />
            </>
          )}
        </PaymentDetailsGate>
      </PaidSubscription.Body>
    </PaidSubscription>
  );
};

export default ProGrowSubscription;
